import styled from '@emotion/styled';
import { Box } from '@mui/material';

const StyledWrapper = styled(Box)`
  /* position: absolute; */
  z-index: 1;
  max-width: 1440px;
  width: 100%;
`;

export default StyledWrapper;
